import Vue from "vue";
import { InMemoryCache } from "apollo-cache-inmemory";
import * as VueGoogleMaps from "vue2-google-maps";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { createProvider } from "@/vue-apollo";
import { resolvers, typeDefs, AlertPlugin, AlertService } from "@ct/alert";
import { LocationService } from "@/components/LocationService";
import { AuthRepository } from "@ct/auth";
import VueClipboard from "vue-clipboard2";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations/dist/vue";
import { CmsPages } from "@/cms/config";
import Meta from "vue-meta";

declare module "vue/types/vue" {
  interface Vue {
    $locationService: LocationService;
    $authRepository: typeof AuthRepository;
    $alertService: AlertService;
    $cmsPages: typeof CmsPages;
  }
}

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBv4DnlbwK7R7iDjwkzDRA3lIPilVM7oTM",
    libraries: "places"
  },
  installComponents: true
});

Vue.config.productionTip = false;
const cache = new InMemoryCache();

const apolloProvider = createProvider({
  cache,
  typeDefs,
  resolvers
});

Vue.use(AlertPlugin, {
  apolloClient: apolloProvider.defaultClient
});

Vue.use(VueClipboard);
Vue.prototype.$locationService = new LocationService();
Vue.prototype.$authRepository = AuthRepository;
Vue.prototype.$cmsPages = CmsPages;

Vue.use(Meta);

// eslint-disable-next-line func-names
(async function() {
  new Vue({
    router,
    vuetify,
    apolloProvider,
    render: h => h(App)
  }).$mount("#app");

  cache.writeData({
    data: {
      alerts: []
    }
  });

  if (process.env.VUE_APP_SENTRY_URL) {
    Sentry.init({
      dsn: process.env.VUE_APP_SENTRY_URL,
      integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true, tracing: true })],
      environment: process.env.VUE_APP_SENTRY_ENV,
      release: process.env.VUE_APP_GIT_SHA || ""
    });
  }
})();
